export default __webpack_public_path__ + "static/media/84.ca05e0d5.jpg";